import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { EmailTemplateFormData } from "@/modules/emailManagement/features/EmailTemplateManagement/hooks/emailTemplateFormSchema";

/**
 * The template's description (what it's for, who gets it and when) and its
 * on/off switch. A member email whose template is off is not sent.
 */
function EmailTemplateStatusFields({
  form,
}: {
  form: UseFormReturn<EmailTemplateFormData>;
}) {
  return (
    <>
      <div className="space-y-2">
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Description</FormLabel>
              <FormControl>
                <Textarea rows={3} {...field} value={field.value ?? ""} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <p className="text-sm text-gray-500 dark:text-gray-400">
          What this template is for, who gets it and when
        </p>
      </div>

      <FormField
        control={form.control}
        name="isActive"
        render={({ field }) => (
          <FormItem className="flex items-center justify-between rounded-lg border border-gray-200 dark:border-slate-700 p-4">
            <div>
              <FormLabel>Active</FormLabel>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                When off, automated emails that use this template are not sent
              </p>
            </div>
            <FormControl>
              <Switch
                aria-label="Active"
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
}

export default EmailTemplateStatusFields;
